import React from "react";
import "./LoaderLogo.css";
import { ReactComponent as Logo } from './Srinath.svg';
class LogoLoader extends React.Component {
  render() {
    return (
      <div>
      <Logo />
    </div>
    );
  }
}

export default LogoLoader;